import Alar from "./Alar60.jpg";
import Aleph from "./AlephBeta60.jpg";
import Barron from "./Barron60.jpg";
import Barton from "./Barton60.jpg";
import BeckG from "./BeckG60.jpg";
import Berlinski from "./Berlinski60.jpg";
import Bevere from "./Bevere60.jpg";
import Buckley from "./Buckley60.jpg";
import Friedman from "./Friedman60.jpg";
import Graham from "./Graham60.jpg";
import HageeM from "./HageeM60.jpg";
import Hillsdale from "./Hillsdale60.jpg";
import KirkC from "./KirkC60.jpg";
import Lennox from "./Lennox60.jpg";
import Levin from "./Levin60.jpg";
import Limbaugh from "./Limbaugh60.jpg";
import LucadoM from "./LucadoM60.jpg";
import Metaxas from "./Metaxas60.jpg";
import Meyer from "./Meyer60.jpg";
import OConnor from "./OConnor60.jpg";
import Pawson from "./Pawson60.jpg";
import Peterson from "./Peterson60.jpg";
import Prager from "./Prager60.jpg";
import Reagan from "./Reagan60.jpg";
import RiccardoJ from "./RiccardoJ60.jpg";
import Schaeffer from "./Schaeffer60.jpg";
import Schneider from "./Schneider60.jpg";
import Sowell from "./Sowell60.jpg";
import Spurgeon from "./Spurgeon60.jpg";
import TenBoom from "./TenBoom60.jpg";
import WilkersonD from "./WilkersonD60.jpg";
import WilkersonG from "./WilkersonG60.jpg";
import Zacharias from "./Zacharias60.jpg";

const AllThumbs = {
    Alar: Alar,
    Aleph: Aleph,
    Barron: Barron,
    Barton: Barton,
    BeckG: BeckG,
    Berlinski: Berlinski,
    Bevere: Bevere,
    Buckley: Buckley,
    Friedman: Friedman,
    Graham: Graham,
    HageeM: HageeM,
    Hillsdale: Hillsdale,
    KirkC: KirkC,
    Lennox: Lennox,
    Levin: Levin,
    Limbaugh: Limbaugh,
    LucadoM: LucadoM,
    Metaxas: Metaxas,
    Meyer: Meyer,
    OConnor: OConnor,
    Pawson: Pawson,
    Peterson: Peterson,
    Prager: Prager,
    Reagan: Reagan,
    RiccardoJ: RiccardoJ,
    Schaeffer: Schaeffer,
    Schneider: Schneider,
    Sowell: Sowell,
    Spurgeon: Spurgeon,
    TenBoom: TenBoom,
    WilkersonD: WilkersonD,
    WilkersonG: WilkersonG,
    Zacharias: Zacharias
}

export default AllThumbs;